export var DataTransferOperationType;
(function (DataTransferOperationType) {
    DataTransferOperationType["DATA_TRANSFER_OPERATION_TYPE_BACKUP"] = "BACKUP";
    DataTransferOperationType["DATA_TRANSFER_OPERATION_TYPE_RESTORE"] = "RESTORE";
})(DataTransferOperationType || (DataTransferOperationType = {}));
